<template>

	<div class="row lobby-article-search-list">

		<div class="col-xs-12">

			<div class="articles-body">

				<div class="text-center mb20">
					<span class="f20">文章搜索: {{title}}</span>
				</div>


				<div v-for="article in pager.articles" class="mb10">

					<span :class="'text-'+article.getTypeMap().style">
						[{{article.getTypeMap().name}}]
					</span>

					<span class="nb-a" @click="$router.push(article.detailPageUrl())">
						<span v-html="highlight(article.title)"></span>
					</span>


					<span class="pull-right">
						{{article.releaseTime | simpleDate}}
					</span>

				</div>

				<div class="mt20">
					<NbPager :pager="pager" :callback="refresh"></NbPager>
				</div>


			</div>
		</div>


	</div>

</template>

<script>
	import NbPager from '../../../common/widget/NbPager.vue'
	import Pager from  "../../../common/model/base/Pager"
	import Article from  "../../../common/model/article/Article"

	export default {
		data () {
			return {
				title: null,
				pager: new Pager(Article)
			}
		},
		computed: {},
		components: {
			NbPager
		},
		watch: {
			'$route' (to, from) {
				this.refresh();
			}
		},
		methods: {
			highlight(title){
				return title.replace(this.title, "<span class='text-danger'>" + this.title + "</span>");
			},
			refresh(){

				this.title = this.$store.state.route.query.title;

				if (this.title) {
					this.pager.setFilter("title", this.title);
				}


				this.pager.setFilter("orderReleaseTime", "DESC");

				this.pager.httpFastPage();
			}
		},
		mounted(){

			this.pager.enableHistory();
			this.refresh();

		}
	}

</script>

<style lang="less" rel="stylesheet/less">

	.lobby-article-search-list {
		.articles-body {
			padding: 40px;
			background-color: white;
			-webkit-border-radius: 5px;
			-moz-border-radius: 5px;
			border-radius: 5px;
		}
	}


</style>






// WEBPACK FOOTER //
// Search.vue?05a2afae